import { CSVFile, processCSV } from "@redotech/csv/csv-parser";
import {
  normalizeBisEmail,
  parseBisCsvRow,
  ParsedBisRow,
  validateBisCsvColumns,
} from "@redotech/redo-model/customer-product-notification/parse-bis-csv-row";

export interface ParseBisCsvResult {
  subscriptions: ParsedBisRow[];
  errors: string[];
  duplicateCount: number;
}

export async function parseBisCsv(file: File): Promise<ParseBisCsvResult> {
  const data: CSVFile = await processCSV(file);
  const subscriptions: ParsedBisRow[] = [];
  const errors: string[] = [];
  const seenKeys = new Set<string>();
  let duplicateCount = 0;

  if (data.rows.length === 0) {
    errors.push("CSV file is empty");
    return { subscriptions, errors, duplicateCount };
  }

  // Validate that required columns exist in first row
  const firstRow = data.rows[0];
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  const columnKeys = Object.keys(firstRow);

  const columnValidation = validateBisCsvColumns(columnKeys);
  if (!columnValidation.valid) {
    return { subscriptions, errors: columnValidation.errors, duplicateCount };
  }

  for (let i = 0; i < data.rows.length; i++) {
    const row = data.rows[i];
    const rowNum = i + 2; // +2 because row 1 is header

    // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
    const result = parseBisCsvRow(row, rowNum);

    if (!result.success) {
      // Skip empty row errors silently
      if (!result.error.includes("Empty row")) {
        errors.push(result.error);
      }
      continue;
    }

    // Check for duplicates within the file
    const key = `${normalizeBisEmail(result.data.email)}|${result.data.productId}|${result.data.variantId}`;
    if (seenKeys.has(key)) {
      duplicateCount++;
      continue;
    }
    seenKeys.add(key);

    subscriptions.push(result.data);
  }

  return { subscriptions, errors, duplicateCount };
}

// eslint-disable-next-line @redotech/no-re-exports -- TODO: remove re-export, update all import sites
export { type ParsedBisRow as BisSubscription } from "@redotech/redo-model/customer-product-notification/parse-bis-csv-row";
